import { FeatureFlags } from '@aibees/elephant/types';
import { IconName } from '@aibees/shared/components';
import { useFeatureFlagsContext } from '@aibees/shared/feature-flags';
import { EnrichButtonDialogType, MenuItem } from './types';

export function useConfig(): MenuItem[] {
  const isPhoneNumberEnabled = useFeatureFlagsContext().isFeatureEnabled(
    FeatureFlags.PEOPLE_PHONE_NUMBER
  );

  const config = [
    {
      label: 'Update Job Changes',
      icon: 'briefcase-arrow-left-right-outline' as IconName,
      dialogType: EnrichButtonDialogType.UpdateJobChange,
      helperText:
        "The job changes for selected contacts are processed and don't need enrichment.",
    },
    {
      label: 'Update Profile Insights',
      icon: 'refresh-user' as IconName,
      dialogType: EnrichButtonDialogType.UpdateProfileInsights,
      helperText:
        "The selected contacts profile insights are already up-to-date and don't need updating.",
    },
    {
      label: 'Enrich Profile Insights',
      icon: 'badge-outline-rounded' as IconName,
      dialogType: EnrichButtonDialogType.EnrichProfileInsights,
      helperText:
        "The selected contacts profile insights are already complete and don't need enrichment.",
    },
    {
      label: 'Enrich Emails',
      icon: 'email-outline' as IconName,
      dialogType: EnrichButtonDialogType.EnrichEmail,
      helperText:
        "The selected contacts emails are already enriched and don't need enrichment.",
    },
    {
      label: 'Re-verify Emails',
      dialogType: EnrichButtonDialogType.ReVerifyEmail,
      icon: 'published-with-changes' as IconName,
      helperText:
        "The selected contacts emails are already verified and don't need re-verification.",
    },
  ];

  if (isPhoneNumberEnabled)
    config.push({
      label: 'Enrich Mobile Phone Numbers',
      icon: 'phone' as IconName,
      dialogType: EnrichButtonDialogType.EnrichPhoneNumber,
      helperText:
        "The selected contacts phone numbers are already enriched and don't need enrichment.",
    });

  return config;
}
